import { DecoratorNode, SerializedLexicalNode, Spread } from "lexical";
import { DataRequest } from "@/ai/autotext";
import { ReactNode } from "react";
import { DCVariableComponent } from "./DCVariableComponent";

export type SerializedDCVariableNode = Spread<
  {
    data: DataRequest;
    type: "dc-variable";
    version: 1;
  },
  SerializedLexicalNode
>;

export class DCVariableNode extends DecoratorNode<ReactNode> {
  __dataRequest: DataRequest;

  constructor(dataRequest: DataRequest, key?: string) {
    super(key);
    this.__dataRequest = dataRequest;
  }

  static getType(): string {
    return "dc-variable";
  }

  static clone(node: DCVariableNode): DCVariableNode {
    return new DCVariableNode(node.__dataRequest, node.getKey());
  }

  getDataRequest(): DataRequest {
    return this.getLatest().__dataRequest;
  }

  setDataRequest(dataRequest: DataRequest): this {
    const self = this.getWritable();
    self.__dataRequest = dataRequest;
    return self;
  }

  createDOM(): HTMLElement {
    return document.createElement("span");
  }

  updateDOM(): false {
    return false;
  }

  decorate(): ReactNode {
    return (
      <DCVariableComponent
        dataRequest={this.getDataRequest()}
        nodeKey={this.getKey()}
        onDataRequestChange={(dataRequest) => this.setDataRequest(dataRequest)}
      />
    );
  }

  isInline(): true {
    return true;
  }

  isIsolated(): boolean {
    return false;
  }

  isKeyboardSelectable(): boolean {
    return true;
  }

  exportJSON(): SerializedDCVariableNode {
    return {
      type: "dc-variable",
      version: 1,
      data: this.getDataRequest(),
    };
  }

  static importJSON(serializedNode: SerializedDCVariableNode): DCVariableNode {
    return new DCVariableNode(serializedNode.data);
  }
}

export function $createDCVariableNode(dataRequest: DataRequest): DCVariableNode {
  return new DCVariableNode(dataRequest);
}
